<a class="link-card link-reset" [routerLink]="['/', 'products', product()?.handle || productPreview()?.handle]">
  <figure class="bg-gray-100">
    @if (product()?.media?.[0]; as media) {
      <app-shopify-media-item
        class="link-card__image"
        [mediaItem]="media"
        [fallbackAlt]="product()?.title || productPreview()?.title"
        [playVideo]="true"
        [sizes]="{ xs: 6, md: 2, lg: 1 }"
      ></app-shopify-media-item>
    } @else if (productPreview()?.imageUrl; as imgUrl) {
      <img
        [src]="imgUrl"
        [alt]="product()?.title || productPreview()?.title"
        class="bg-gray-100 link-card__image product-image product-image-ratio"
      />
    }
  </figure>

  <main>
    <h2 class="mb-0 product-card__content__title h5 fw-normal">
      {{ product()?.title || productPreview()?.title }}
    </h2>
    <span class="type-body-sm">{{ product()?.productType }}</span>

    @if (product()?.priceRange?.minVariantPrice; as minPrice) {
      <div class="product-card__content__meta type-body-md">
        <small class="me-1 type-body-xs">{{ 'product-card-vanaf-prijf-prefix' | fromDictionary }}</small>
        @if (product()?.compareAtPriceRange?.minVariantPrice; as comparePrice) {
          @if (+comparePrice.amount > +minPrice.amount) {
            <div class="d-inline-flex flex-column">
              <del class="product-card__discount-before-price price--old type-body-xs">
                {{ comparePrice.amount | currency: comparePrice.currencyCode }}
              </del>
              <strong class="price--new">{{ minPrice?.amount | currency: minPrice.currencyCode }}</strong>
            </div>
          } @else {
            {{ minPrice?.amount | currency: minPrice.currencyCode }}
          }
        } @else {
          {{ minPrice?.amount | currency: minPrice.currencyCode }}
        }
      </div>
    } @else if (productPreview()?.subtitle) {
      <div class="type-body-md">
        {{ productPreview()?.subtitle }}
      </div>
    }
  </main>

  <span class="flex-shrink-0 button button-outline button--secondary button-icon ms-auto me-3">
    <app-icon anchor="icon-arrow-right"></app-icon>
  </span>
</a>
